export const darkThemePaths = [
  '/',
  '/app',
  '/blackfriday',
  '/blackfriday/[username]',
  '/blackfriday/blackout',
  '/brand/[slug]',
  '/manifesto',
];
